import { useEffect, useState, type ChangeEvent } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel, PanelLabel } from "@/components/PageHeader";
import { api, formatApiError } from "@/lib/api";
import { STATUS_LABELS } from "@/lib/billing";

interface Stats { counts: Record<string, number>; signups_month: number; cancellations_month: number; guarantees_month: number; guarantees_amount_month: number; prices: { monthly: number; annual: number } }


export function AdminBillingCard() {
  const [s, setS] = useState<Stats | null>(null);
  const [prices, setPrices] = useState({ monthly: 0, annual: 0 });
  useEffect(() => { api.get<Stats>("/admin/billing").then((r) => { setS(r.data); setPrices(r.data.prices); }).catch(() => undefined); }, []);
  if (!s) return null;
  const save = async () => {
    try { await api.put("/admin/billing/prices", prices); toast.success("Precios actualizados; aplican a nuevas suscripciones"); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <Panel testId="admin-billing" className="mt-6">
      <PanelLabel>Suscriptores</PanelLabel>
      <div className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {["trialing", "active", "past_due", "canceling", "expired", "none"].map((k) => (
          <div key={k} className="rounded-xl bg-[#F5F6F8] p-3"><p className="text-xs text-slate-500">{STATUS_LABELS[k]}</p><p className="font-display text-2xl font-extrabold text-[#1B2A4A]" data-testid={`admin-billing-${k}`}>{s.counts[k]}</p></div>
        ))}
      </div>
      <p className="mt-3 text-sm text-slate-600" data-testid="admin-billing-month">Este mes: {s.signups_month} altas · {s.cancellations_month} cancelaciones · <span data-testid="admin-billing-guarantees">{s.guarantees_month} garantías usadas (${s.guarantees_amount_month.toLocaleString("es-MX")} MXN)</span></p>
      <div className="mt-4 flex flex-wrap items-end gap-3">
        {(["monthly", "annual"] as const).map((k) => (
          <label key={k} className="text-sm text-slate-700">{k === "monthly" ? "Precio mensual (MXN)" : "Precio anual (MXN)"}
            <Input type="number" min={1} value={prices[k]} onChange={(e: ChangeEvent<HTMLInputElement>) => setPrices({ ...prices, [k]: Number(e.target.value) })} className="mt-1 h-10 w-40" data-testid={`admin-price-${k}`} />
          </label>
        ))}
        <Button onClick={save} className="h-10 bg-[#1B2A4A] text-white hover:bg-[#2A3D63]" data-testid="admin-prices-save">Guardar precios</Button>
      </div>
    </Panel>
  );
}
